angular.module('aprima-provider-api')
    .factory('DiagnosisRepository', ['AprimaRestangular', function (aprimaRestangular) {
        'use strict';

        var getDiagnoses = function (searchString, records, codeType) {
            records = records || 20;
            
        	var queryString = '?maxRecords=' + records;
            
            if(!codeType){
                queryString += '&diagnosisText=';
            } else if(codeType === 'ICD10'){
                queryString += '&icd10Code=';
            } else{
                queryString += '&icd9Code=';
            }
            
            queryString += searchString;

            return aprimaRestangular.get().all('diagnoses/' + queryString).getList();
        };
        
        var getModifiers = function(){
            return aprimaRestangular.get().all('diagnosis/modifiers').getList();
        };

        return {
            getDiagnoses: getDiagnoses,
            getModifiers: getModifiers
        };

    }]);